import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-detail-entry-field',
  standalone: true,
  imports: [],
  templateUrl: './detail-entry-field.component.html',
  styleUrl: './detail-entry-field.component.scss'
})
export class DetailEntryFieldComponent {
  @Input() public label: string = '';
}
